import { CardPreviewImage } from "~/components/molecules/card/CardPreviewImage";
import type { CardType } from "~/types/card";

type Props = {
  cards: CardType[];
};

export const CardPreviewList = ({ cards }: Props) => {
  return (
    <div className="flex flex-row flex-wrap justify-center sm:justify-start">
      {cards.map((card) => {
        return (
          <div key={card.id} className="m-1 duration-500 animate-in fade-in">
            <CardPreviewImage card={card} />
          </div>
        );
      })}
    </div>
  );
};
